import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScarabLoader = ({ siteId }) => {
  const location = useLocation();

  useEffect(() => {

    if (!siteId) {
      console.warn('ScarabLoader: Missing siteId');
      return;
    }  
    
    const scriptId = 'scarab-js-api';

    if (location.pathname.startsWith('/service-monitor')) {
      const existingScript = document.getElementById(scriptId);
      if (existingScript && existingScript.parentNode) {
        existingScript.remove();
      }
      return;
    }

    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `//cdn.scarabresearch.com/js/${siteId}/scarab-v2.js`;
      document.body.appendChild(script);
    }
  }, [location.pathname, siteId]);

  return null;
};